
<template>
  <div class="container">
    <CommonFrame :workNo="workNo"
                  :btns="btns"
                  :node="node"
                  :breadcrumb="breadcrumb"
                  :endStatus="approvalParams.endStatus"
                  :approvalTabStatus="approvalParams.approvalTabStatus"
    >
    <div slot="info">
        <h4>
          <span>商品名称:</span>
          <span>{{name}}</span>
        </h4>
        <span v-for="(item,index) in titleInfo" class="padding-span" style="margin-right:8px" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="价格调整信息">
            <lk-form
              label-position="right"
              :label-width="140"
              v-if="!isMultiPrice"
            >
              <lk-row :gutter="16">
                <lk-col span="10" >
                  <lk-form-item label="本次调整单价:">
                    <span>{{this.price.price}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="生效时间：">
                    <span>{{this.price.effectTime}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="调整幅度：">
                    <span>{{this.price.adjustmentRangeStr || ''}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="调整原因：" >
                    <span>{{this.price.adjustmentReasonName || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="有进价调整：">
                    <span>{{priceAdjustment}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="最新进价：" v-if="priceAdjustment === '有'">
                    <span>{{this.price.latestPrice || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="价格补偿：">
                    <span>{{priceCompensation}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="补偿时间：" v-if="priceCompensationIf">
                    <span>{{this.price.compensationTime}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="补偿形式：" v-if="priceCompensationIf">
                    <span>{{this.price.compensationForm || ''}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="补偿协议：" v-if="priceCompensationIf">
                    <Uploader
                      v-model.trim='this.price.compensationAgreement'
                      :able="false"
                    ></Uploader>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="20">
                  <lk-form-item label="预估返利明细：">
                    <lk-table border :columns="rebateInfo" :data="rebateData" v-if="!isMultiPrice"/>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
            <lk-table border :columns='multiPriceColumns' :data="multiTableData" v-else></lk-table>
          </lk-card>
        </div>

        <div class="cardContainer">
          <lk-card title="价格调整记录">
            <lk-table border :columns='isMultiPrice ? multiPriceChangeColumns : columns' :data='isMultiPrice ? multiPriceChangeTableData : tableData'></lk-table>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>
<script>

import axios from 'axios';
import utils from '@/libs/utils';
import CommonFrame from '../commonFrame.vue';
import Uploader from '../../../components/Uploader.vue';
import sharedDara from '@/libs/sharedDara.js';

export default {
  name: 'priceFlowInfo',
  components: {
    CommonFrame,
    Uploader,
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  data() {
    return {
      isMultiPrice: false,
      titleInfo: [],
      workNo: '',
      node: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '销售价格审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      rebateInfo: [
        { title: '供应商名称', minWidth: 200, key: 'supplierName' },
        { title: '预估返利(元)', width: 116, key: 'estimateAmount' },
        { title: '返利计算规则', width: 200, key: 'rebateRule' },
        { title: '备注', width: 200, key: 'remark' },
        { title: '在途冻结数量', key: 'transportingNum', minWidth: 116 },
        { title: '系统冻结数量', key: 'sysFrozenNum', minWidth: 116 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 116 },
        { title: '可销售数量', key: 'num', minWidth: 116 },
        { title: '库存总数量', key: 'totalNum', minWidth: 116 },
      ],
      rebateData: [],
      infosArr: [],
      name: '',
      idText: '',
      adjustmentReasonList: [],
      price: [
        { title: '销售单价', key: 'price', minWidth: 116 },
        { title: '调整原因', key: 'modifiedReason', minWidth: 116 },
      ],
      columns: [
        {
          title: '序号',
          minWidth: 116,
          render: (h, params) => h('span', params.index + 1),
        },
        { title: '调整前价格', key: 'beforeSalePrice', minWidth: 116 },
        { title: '调整后价格', key: 'price', minWidth: 116 },
        { title: '调整原因', key: 'adjustmentReasonName', minWidth: 116 },
        { title: '生效时间', key: 'effectTime', minWidth: 116 },
        { title: '价格补偿', key: 'priceCompensation', minWidth: 116 },
        { title: '补偿时间', key: 'compensationTime', minWidth: 116 },
        {
          title: '补偿协议',
          minWidth: 166,
          render: (h, params) => h(
              Uploader,
              {
                props: {
                  url: params.row.compensationAgreement,
                  able: false,
                },
              }
            )
        },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
      ],
      tableData: [],
      multiTableData: [], // 多价格调整信息数据
      multiPriceChangeTableData: [], // 多价格调整记录数据
      multiPriceColumns: [
        {
          title: '序号',
          minWidth: 116,
          render: (h, params) => h('span', params.index + 1),
        },
        { title: '价格', key: 'price', minWidth: 116 },
        {
          title: '应用范围',
          minWidth: 116,
          render: (h, params) => params.row.rangeNames && params.row.rangeNames.length ?
          h('span', params.row.rangeNames.join(',')) : h('span', '-')
        },
        { title: '备注', key: 'remark', minWidth: 116 },
      ],
      multiPriceChangeColumns: [
        {
          type: 'expand',
          width: 50,
          render:(h, params) =>
            params.row.salePriceCityHistoryList && params.row.salePriceCityHistoryList.length && h(
              'lk-table',
              {
                props: {
                  border: true,
                  columns: this.multiPriceChangeChildrenColumns,
                  data: params.row.salePriceCityHistoryList,
                },
              }
            )
        },
        {
          title: '序号',
          minWidth: 116,
          render:(h, params) => h(
            'span',
            `${params.index + 1}`,
          ),
        },
        {
          title: '审批状态',
          key: 'statusApproval',
          minWidth: 116,
          render:(h, params) => utils.isEmpty(params.row.statusApproval) ? h('span', '-') :
          h('span', ['', '审批中', '审批通过', '审批驳回'][params.row.statusApproval])
        },
        { title: '调整原因', key: 'modifiedReason', minWidth: 140 },
        { title: '操作', key: 'operate', minWidth: 116 },
        { title: '操作人', key: 'createUserName', minWidth: 116 },
        { title: '操作时间', key: 'createTime', minWidth: 116 },
      ],
      multiPriceChangeChildrenColumns: [
        { title: '序号',
          minWidth: 80,
          render:(h, params) => 
            h(
              'span',
              params.index + 1,
            )
        },
        {
          title: '应用范围',
          key: 'cityName',
          minWidth: 250,
        },
        {
          title: '调整前价格',
          minWidth: 116,
          render: (h, params) =>
            h(
              'span',
              utils.isEmpty(params.row.oldPrice) ? '-' : params.row.oldPrice,
            )
        },
        { title: '操作', key: 'operateName', minWidth: 116 },
        {
          title: '调整后价格',
          minWidth: 116,
          render: (h, params) => 
            h(
              'span',
              utils.isEmpty(params.row.newPrice) ? '-' : params.row.newPrice,
            )
        },
        {
          title: '价格备注',
          minWidth: 116,
          render: (h, params) => 
            h(
              'span',
              utils.isEmpty(params.row.remark) ? '-' : params.row.remark,
            )
        },

      ],
      // approvalStatus: [null, '审批中', '审批成功', '审批失败'],
    };
  },
  methods: {
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        // newSalePrice;
        // salePriceVersionList;
        if (res.data.status === 200) {
          const item = res.data.data.newSalePrice;
          // const result = [];
          if (item.hasOwnProperty('rebateVoList')) {
            this.rebateData = item.rebateVoList;
          }
          this.name = item.goodsName;
          this.titleInfo = [
            {
              name: '商品ID',
              value: item.goodsStoreId,
            },
            {
              name: '商品编码',
              value: item.drugSerialCode,
            },
            {
              name: '通用名称',
              value: item.approvedDrugNames,
            },
            {
              name: '规格',
              value: item.specifications,
            },
          ];
          // utils.exchangeTable(item, result);
          // console.log(result);
          // result.price /= 100;
          // result.loading = false;
          this.price = item;
          this.price.effectTime = item.effectTime ? utils.formatDate(item.effectTime) : '';
          this.price.compensationTime = item.compensationTime ? utils.formatDate(item.compensationTime) : '';
          if (item.salePriceCityRelList && item.salePriceCityRelList.length) {
            this.isMultiPrice = true;
            this.multiTableData = item.salePriceCityRelList;
          }

          const priceList = res.data.data.salePriceVersionList;

          priceList.forEach((priceItem) => {
            priceItem.createTime = utils.exchangeTimeToSecond(priceItem.createTime);
            priceItem.effectTime = priceItem.effectTime && utils.formatDate(priceItem.effectTime);
            priceItem.compensationTime = priceItem.compensationTime && utils.formatDate(priceItem.compensationTime);
            priceItem.adjustmentReasonName = priceItem.adjustmentReason ? this.adjustmentReasonList[priceItem.adjustmentReason - 1].name : '';
            if (priceItem.priceCompensation) {
              priceItem.priceCompensation = priceItem.priceCompensation === 1 ? '有' : '无'; // 后端返回1代表有，2是无。
            }
            if (priceItem.adjustmentReason) {
              priceItem.adjustmentReasonName = this.adjustmentReasonList[priceItem.adjustmentReason - 1].name;
            }
            if (this.isMultiPrice) {
              if (priceItem.salePriceCityHistoryList && priceItem.salePriceCityHistoryList.length) {
                this.multiPriceChangeTableData.push(priceItem);
              }
            } else {
              this.tableData.push(priceItem);
            }
          });
        } else {
          this.$Message.error(res.data.error);
        }
        // console.log(this.tableData)
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  computed: {
    priceCompensation() {
      let priceCompensation = '';
      if (this.price.priceCompensation) {
        if (this.price.priceCompensation === 1) {
          priceCompensation = '有';
        } else {
          priceCompensation = '无';
        }
      } else {
        priceCompensation = '无';
      }
      return priceCompensation;
    },
    priceAdjustment() {
      let priceAdjustment = '';
      if (this.price.priceAdjustment) {
        if (this.price.priceAdjustment === 1) {
          priceAdjustment = '有';
        } else {
          priceAdjustment = '无';
        }
      } else {
        priceAdjustment = '';
      }
      return priceAdjustment;
    },
    priceCompensationIf() {
      return this.price.priceCompensation === 1;
    },
  },
  mounted() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.getInfo(this.approvalParams.businessUrl);
    this.adjustmentReasonList = sharedDara.adjustmentReasonList;
  },
};
</script>
